// configPlugin.js

//let VueInstance;

const ConfigPlugin = {
  install(Vue, options) {
    //VueInstance = Vue;

    // Define your global config variables
    let configVariables = {
      apiUrl: 'https://api.missingink.com',
      appName: 'Missingink Dashboard',
      user: '',
      token: '',
      moniker: '',
      sites: '',

    };

    // Add the config variables to Vue.prototype
    Vue.prototype.$config = configVariables;

    // Add a method to update config variables
    Vue.prototype.$updateConfigVariables = function (newVariables) {        
      Object.assign(configVariables, newVariables);
      // Emit an event to notify components about the update
      //Vue.$emit('configVariables:update', configVariables);


    };
  },
};

export default ConfigPlugin;
